import {NodeTree} from "./NodeTree";
import { gql } from '@apollo/client'

export class DirectUnitQueryBuilder {
    constructor(unitName) {
        this.unitName = unitName;
        this.nodeTree = new NodeTree(this.unitName);
    }

    build(context) {
        // Obtengo las caracteristicas de los campos/columnas y mapeos.
        context.fieldDescriptions.forEach(desc => {
            if (desc.tableMapper && desc.tableMapper.mapperPaths) {
                desc.tableMapper.mapperPaths.forEach(path => {
                    const p = Array.isArray(path) ? path.join('.') : path;
                    this.nodeTree.addPath(p);
                });
            }
        });
        // Asegurar id básico
        this.nodeTree.addPath('id');
        return this;
    }

    toString() {
        // Imprime solo el field raíz con sus hijos (para interpolación dentro de otra query)
        // const children = (this.nodeTree.children.length > 0 ? this.nodeTree.children : [new NodeTree('id')])
        //     .map(child => child.format(4, 2)).join('\n');
        return `${this.unitName}(id: $id) {\n${this.nodeTree.format(4,2)}\n}`;
    }

    getQueryName() {
        // Nombre del field raíz, usado para mapear data[unitQueryName]
        return this.unitName;
    }

    getQueryString() {
        const opName = this.unitName.substring(0, 1).toUpperCase() + this.unitName.substring(1);
        const children = (this.nodeTree.children.length > 0 ? this.nodeTree.children : [new NodeTree('id')])
            .map(child => child.format(4, 2)).join('\n');
        const formatted =
`query ${opName} ($id: String!) {
    ${this.unitName}(id: $id) {
${this.nodeTree.format(4,2)}
    }
}`;
        return formatted;
    }

    getGql() {
        return gql`${this.getQueryString()}`;
    }
}
